import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DropdownMenu } from '@3plearning/react-components';
import { REPORT_LIST, SKILL_QUESTS_MASTERY_OPTION } from '../filter-constants';
import { dropdownItemPropType } from '../filter-prop-types';
import dropdownDataSelectors from '../redux/dropdown-data/dropdown-data-selectors';
import dropdownDataActions from '../redux/dropdown-data/dropdown-data-actions';

export class ReportDropdown extends PureComponent {
    static propTypes = {
        reportDropdownData: PropTypes.shape({
            data: PropTypes.arrayOf(dropdownItemPropType),
            selectedOption: dropdownItemPropType,
            disabled: PropTypes.bool
        }),
        className: PropTypes.string,
        isAdmin: PropTypes.bool,
        handleApplyFilters: PropTypes.func
    };

    optionSelected = async (selectedOption) => {
        await this.props.setDropdownData({
            [REPORT_LIST]: { selectedOption }
        });

        this.props.handleApplyFilters();
    };

    getReportOptions = (options) => {
        const { isAdmin } = this.props;

        if (isAdmin) {
            return options.filter(
                (option) => option.value !== SKILL_QUESTS_MASTERY_OPTION.value
            );
        }

        return options;
    };

    getTranslatedOptions = (options) => {
        const i18n = window.i18n;

        if (i18n) {
            return options.map((item) => {
                const updatedLabel = `Report Filters - ${item.label}`;
                return {
                    ...item,
                    label: i18n._(updatedLabel)
                };
            });
        }

        return options;
    };

    getTranslatedSelectedOption = (selectedOption) => {
        const i18n = window.i18n;

        if (i18n) {
            const updatedLabel = `Report Filters - ${selectedOption.value}`;

            return {
                ...selectedOption,
                label: i18n._(updatedLabel)
            };
        }

        return selectedOption;
    };

    render() {
        const { reportDropdownData, className } = this.props;
        const { data, selectedOption, disabled } = reportDropdownData;
        const updatedReportOptions = this.getReportOptions(data);

        return (
            <DropdownMenu
                className={className}
                options={this.getTranslatedOptions(updatedReportOptions)}
                selectedOption={this.getTranslatedSelectedOption(
                    selectedOption
                )}
                onSelectOption={this.optionSelected}
                disabled={disabled}
            />
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        reportDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            REPORT_LIST
        )(state),
        isAdmin: state.isAdmin
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        { setDropdownData: dropdownDataActions.setDropdownData },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDropdown);



// WEBPACK FOOTER //
// ./components/report-filters/dropdown-menus/report-dropdown.js